<template>
  <div class="text-center">
    <img
      src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/Logo8.png"
      width="350"
      height="97"
      class="mx-auto my-5 img-fluid px-4 px-lg-0"
    />
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/generales/Cargando.vue